import t from "./types";
import apiType from "../APIResponseActions/type";
import { AuthAPI, BufferAuthAPI } from "../../../Auth/requestHandler";
import moment from "moment";
import moment_timezone from "moment-timezone";

export const fetchCurrentPermits = (pageobj) => async (dispatch) => {
  try {
    let url = "";
    const unix_time = Math.round(new Date().getTime() / 1000);
    const currentDate = unix_time - 14400;
    const exportPemrits = !!(pageobj && pageobj.exportLink);
    url =
      "permit?permit_type=" +
      pageobj.permitType +
      "&status=" +
      pageobj.status +
      "&suite_id=" +
      pageobj.suite_id +
      "&page_size=" +
      pageobj.Norow +
      "&page=" +
      pageobj.page +
      "&search=" +
      pageobj.searchValue +
      "&order_by=" +
      pageobj.selectedColumn +
      "&sorting=" +
      pageobj.sort_direction +
      "&current_time=" +
      currentDate +
      "&exportLink=" +
      exportPemrits;
    if (exportPemrits) {
      try {
        return await BufferAuthAPI("domain", url, "GET");
      } catch (error) {
        await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
      }
    } else {
      const data = await AuthAPI("domain", url, "GET");
      await dispatch({ type: t.FETCH_CURRENT_PERMIT, payload: data });
      await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: "" });
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const AddPermits =
  (
    bookingSlots,
    confirm_data,
    userDetails,
    permit_credit_group,
    credit_type,
    timezone
  ) =>
  async (dispatch) => {
    try {
      console.log(
        "permit_credit_grouppermit_credit_group",
        permit_credit_group,
        userDetails
      );
      const dateFormateWithTime = "YYYY/MM/DD HH:mm";
      const start_reservation_time = moment(bookingSlots[0].startDate)
        .utcOffset(timezone)
        .format(dateFormateWithTime);
      const end_reservation_time = moment(
        bookingSlots[bookingSlots.length - 1].endDate
      )
        .utcOffset(timezone)
        .format(dateFormateWithTime);
      console.log("start_reservation_time=========", start_reservation_time);
      const formatedBT = moment(start_reservation_time).format(
        "YYYY-MM-DD HH:mm:SS"
      );
      const convertedBeginTime = moment_timezone
        .tz(formatedBT, timezone)
        .format();
      const UTCBT = moment_timezone.tz(convertedBeginTime, "UTC").format();
      const formatedET = moment(end_reservation_time).format(
        "YYYY-MM-DD HH:mm:SS"
      );
      const convertedExpireTime = moment_timezone
        .tz(formatedET, timezone)
        .format();
      const UTCET = moment_timezone.tz(convertedExpireTime, "UTC").format();
      console.log(
        "timezone======",
        timezone,
        "formatedBT=========",
        formatedBT,
        "convertedBeginTime=====",
        convertedBeginTime,
        "UTCBT=========",
        UTCBT
      );
      const total_credit = permit_credit_group.reduce((acc, el) => {
        return acc + parseInt(el.credits);
      }, 0);
      let dataToSend = {};
      console.log("data before sending", confirm_data);
      const data_permit = [];
      if (confirm_data.multiplePermits) {
        bookingSlots.forEach((element) => {
          const formatedBT = moment(element.startDate).format(
            "YYYY-MM-DD HH:mm:SS"
          );
          const convertedBeginTime = moment_timezone
            .tz(formatedBT, timezone)
            .format();
          const UTCBT = moment_timezone.tz(convertedBeginTime, "UTC").format();
          const formatedET = moment(element.endDate).format(
            "YYYY-MM-DD HH:mm:SS"
          );
          const convertedExpireTime = moment_timezone
            .tz(formatedET, timezone)
            .format();
          const UTCET = moment_timezone.tz(convertedExpireTime, "UTC").format();
          data_permit.push({
            creator_uid: userDetails.uid,
            company_id:
              userDetails && userDetails.company_id
                ? userDetails.company_id
                : "",
            property_id: userDetails.property_id,
            lot_id: userDetails?.LotVisitorsId,
            begin_time: UTCBT, // moment(element.startDate)
            expire_time: UTCET, // moment(element.endDate)
            role: "visitor",
            permit_class: "Visitor",
            cost: element.credits, // changed this from bookingSlots.length to total_credit
            email: userDetails.email,
            suite_id: userDetails.suite_id,
            ...(confirm_data && {
              first_name: confirm_data.firstName ? confirm_data.firstName : "",
              last_name: confirm_data.lastName ? confirm_data.lastName : "",
              country_code: confirm_data.country_code
                ? confirm_data.country_code
                : "+1",
              phone: confirm_data.phone ? confirm_data.phone : "",
              phone_options: confirm_data.phone_options
                ? confirm_data.phone_options
                : [],
              lpn: confirm_data.plateNumber ? confirm_data.plateNumber : "",
              car_make: confirm_data.vehicle_make
                ? confirm_data.vehicle_make
                : "",
              car_model: confirm_data.vehicle_model
                ? confirm_data.vehicle_model
                : "",
              car_color: confirm_data.vehicle_color
                ? confirm_data.vehicle_color
                : "",
            }),
            ...{
              group_name: element.group_name,
              credits: element.credits,
            },
          });
        });
        if (credit_type === "single") {
          dataToSend = {
            credit_type: credit_type,
            permit: data_permit,
            multiple_permits: confirm_data.multiplePermits,
          };
        } else if (credit_type === "multiple") {
          dataToSend = {
            credit_type: credit_type,
            permit: data_permit,
            permit_credit_group: [],
            multiple_permits: confirm_data.multiplePermits,
          };
        }
      } else {
        const data_permit = [
          {
            creator_uid: userDetails.uid,
            company_id: userDetails.CompanyId,
            property_id: userDetails.property_id,
            lot_id: userDetails?.LotVisitorsId,
            begin_time: UTCBT, // start_reservation_time,
            expire_time: UTCET, // end_reservation_time,
            role: "visitor",
            permit_class: "Visitor",
            cost: total_credit, // changed this from bookingSlots.length to total_credit
            email: userDetails.email,
            suite_id: userDetails.suite_id,
            ...(confirm_data && {
              first_name: confirm_data.firstName ? confirm_data.firstName : "",
              last_name: confirm_data.lastName ? confirm_data.lastName : "",
              country_code: confirm_data.country_code
                ? confirm_data.country_code
                : "+1",
              phone: confirm_data.phone ? confirm_data.phone : "",
              phone_options: confirm_data.phone_options
                ? confirm_data.phone_options
                : [],
              lpn: confirm_data.plateNumber ? confirm_data.plateNumber : "",
              car_make: confirm_data.vehicle_make
                ? confirm_data.vehicle_make
                : "",
              car_model: confirm_data.vehicle_model
                ? confirm_data.vehicle_model
                : "",
              car_color: confirm_data.vehicle_color
                ? confirm_data.vehicle_color
                : "",
            }),
          },
        ];
        if (credit_type === "single") {
          dataToSend = {
            credit_type: credit_type,
            permit: data_permit,
            multiple_permits: confirm_data.multiplePermits,
          };
        } else if (credit_type === "multiple") {
          dataToSend = {
            credit_type: credit_type,
            permit: data_permit,
            permit_credit_group: permit_credit_group,
            multiple_permits: confirm_data.multiplePermits,
          };
        }
      }

      const response3 = await AuthAPI("domain", "permit", "POST", dataToSend);
      if (response3 && response3.success) {
        await dispatch({
          type: apiType.API_RESPONSE_SUCCESS,
          payload: response3.msg,
        });
      } else {
        await dispatch({
          type: apiType.API_RESPONSE_FAILURE,
          payload: response3.message,
        });
      }
    } catch (error) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: error.toString(),
      });
    }
  };

export const getTimeSlot = (suite_id) => async (dispatch) => {
  try {
    let unix_time = Math.round(new Date().getTime() / 1000);
    unix_time = unix_time - 14400;
    const data = await AuthAPI(
      "domain",
      "timeslot?current_date=" + unix_time + "&suite_id=" + suite_id,
      "GET"
    );
    console.log("==", data);
    await dispatch({ type: t.FETCH_TIME_SLOT, payload: data });
    await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: "" });
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};
export const fetchResidentList = (suite_id) => async (dispatch) => {
  try {
    const response = await AuthAPI(
      "domain",
      "user/residents/of-property",
      "GET"
    );
    await dispatch({ type: t.FETCH_RESIDENT_LIST, payload: response.data });
    await dispatch({ type: apiType.API_RESPONSE_SUCCESS, payload: "" });
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const getCreditsIndividualDetails =
  (suite_id, propertyId) => async (dispatch) => {
    try {
      let unix_time = Math.round(new Date().getTime() / 1000);
      unix_time = unix_time - 14400;
      const resource =
        "permit/" + propertyId + "/" + suite_id + "/" + unix_time;
      const response = await AuthAPI("domain", resource, "GET");

      await dispatch({
        type: t.FETCH_CREDITS_ALLOCATED,
        payload: response.credits_individual_detail,
      });
      await dispatch({
        type: t.FETCH_SINGLE_CREDIT_AVAILABILITY,
        payload: response.single_credit_availability,
      });
      await dispatch({
        type: t.FETCH_CREDITS_USED_30DAYS,
        payload: response.credit_used_30days,
      });
      await dispatch({
        type: t.FETCH_CREDITS_30DAYS_REEPORTS,
        payload: response.credit_30days_reports,
      });
    } catch (error) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: error.toString(),
      });
    }
  };

export const getCurrentPermits =
  (propertyId, availableSpots, credit, suite_id) => async (dispatch) => {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const dateFormateWithTime = "YYYY/MM/DD HH:mm";
      let unix_time = Math.round(new Date().getTime() / 1000);
      unix_time = unix_time - 14400;
      const resource =
        "permit/" + propertyId + "/" + suite_id + "/" + unix_time;
      const response = await AuthAPI("domain", resource, "GET");
      console.log("getCurrentPermits:::::---", suite_id);
      const timeslotData = await AuthAPI(
        "domain",
        "timeslot?current_date=" + unix_time + "&suite_id=" + suite_id,
        "GET"
      );

      let data_parked = response.current_permits;
      data_parked = data_parked.filter((item) => {
        return item.permit_class === "Visitor";
      });
      // (allValues.fields ?? [])
      //   .map()
      (data_parked ?? []).map((item) => {
        item.BeginTime = moment(item.BeginTime)
          .utcOffset(timezone)
          .format(dateFormateWithTime);
        item.ExpiryTime = moment(item.ExpiryTime)
          .utcOffset(timezone)
          .format(dateFormateWithTime);
        return item;
      });
      const timeSlot = timeslotData.time_slot;
      const dateSlot = timeslotData.date_slot;
      const available_spot = timeslotData.available_spot;
      await dispatch({
        type: t.SET_AVAILABLESPOTS,
        payload: timeslotData.available_spot,
      });
      await dispatch({
        type: t.FETCH_DATE_LIST,
        payload: { data_parked, credit, timeSlot, dateSlot, available_spot },
      });
      await dispatch({
        type: t.FETCH_RESIDENTSCREDITSARR,
        payload: response.credits,
      });
      await dispatch({
        type: t.FETCH_RESIDENTSPASTCREDITSARR,
        payload: response.past_credits,
      });
      await dispatch({
        type: t.FETCH_USED_CREDITS,
        payload: response.past_credit_individual_detail,
      });
      await dispatch({
        type: t.FETCH_CURRENT_CREDITS,
        payload: response.credits_individual,
      });
      await dispatch({
        type: t.FETCH_CREDITS_ALLOCATED,
        payload: response.credits_individual_detail,
      });
      await dispatch({
        type: t.FETCH_CREDITS_30DAYS_REEPORTS,
        payload: response.credit_30days_reports,
      });
      await dispatch({
        type: t.FETCH_CREDITS_USED_30DAYS,
        payload: response.credit_used_30days,
      });
      await dispatch({
        type: t.FETCH_PAST_CREDITS_ALLOCATED,
        payload: response.past_credits_individual,
      });
      await dispatch({
        type: t.FETCH_SINGLE_CREDIT_AVAILABILITY,
        payload: response.single_credit_availability,
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.msg,
      });
    } catch (error) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: error.toString(),
      });
    }
  };

export const deActivatePermit = (permitId) => async (dispatch) => {
  try {
    const resource = "permit/" + permitId + "/deactivate";
    const response = await AuthAPI("domain", resource, "PATCH");
    await dispatch({ type: t.UPDATE_CURRENT_PERMIT, payload: permitId });
    await dispatch({
      type: apiType.API_RESPONSE_SUCCESS,
      payload: response.message,
    });
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const call_when_here_activate_deactive =
  (permitId) => async (dispatch) => {
    try {
      const url = "permit/call_when_here/" + permitId;
      const response = await AuthAPI("domain", url, "GET");
      await dispatch({
        type: t.CALL_WHEN_HERE_ACTIVATE_DEACTIVATE,
        payload: permitId,
      });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.msg,
      });
    } catch (error) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: error.toString(),
      });
    }
  };

export const setResidentCredits = (config) => async (dispatch) => {
  await dispatch({ type: t.FETCH_CREDITS, payload: config });
};

export const getResidentPermits =
  (suite_id, propertyId) => async (dispatch) => {
    try {
      const resource = "permit/resident/" + suite_id + "/" + propertyId;
      const response = await AuthAPI("domain", resource, "GET");
      await dispatch({ type: t.FETCH_RESIDENTS_PERMIT, payload: response });
    } catch (error) {
      await dispatch({
        type: apiType.API_RESPONSE_FAILURE,
        payload: error.toString(),
      });
    }
  };

export const updatePermit = (permitId, body) => async (dispatch) => {
  try {
    const resource = "permit/" + permitId;
    body.id = permitId;

    const response = await AuthAPI("domain", resource, "PATCH", body);
    await dispatch({ type: t.UPDATE_PERMIT, payload: body });
    if (response.success === 1) {
      dispatch({
        type: t.UPDATE_PERMIT_SUCCESS,
        payload: response.message,
      });
      await dispatch({ type: t.FETCH_CURRENT_PERMIT, payload: response.data });
    } else {
      await dispatch({
        type: t.UPDATE_PERMIT_ERROR,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({
      type: apiType.API_RESPONSE_FAILURE,
      payload: error.toString(),
    });
  }
};

export const visitorPermitDelete = (id) => async (dispatch) => {
  try {
    const url = "permit/" + id;
    const response = await AuthAPI("domain", url, "DELETE");
    if (response && response.success) {
      await dispatch({ type: t.DELETE_VISITOR, payload: id });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const addSharingLots = (data) => async (dispatch) => {
  try {
    const url = "lot/add-lot-sharing";
    const response = await AuthAPI("domain", url, "POST", data);
    if (response && response.success) {
      await dispatch({ type: t.GET_SHARED_LOT, payload: response.data });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const get_shared_lots = (propertyId) => async (dispatch) => {
  try {
    const url = "lot/get-all-shared-lot?property_id=" + propertyId;
    const response = await AuthAPI("domain", url, "GET");
    if (response) {
      await dispatch({ type: t.GET_SHARED_LOT, payload: response });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};

export const deleteSharingLots = (property_id, id) => async (dispatch) => {
  try {
    const url =
      "lot/delete-lot-sharing?property_id=" + property_id + "&id=" + id;
    const response = await AuthAPI("domain", url, "DELETE");
    if (response && response.success) {
      await dispatch({ type: t.GET_SHARED_LOT, payload: response.data });
      await dispatch({
        type: apiType.API_RESPONSE_SUCCESS,
        payload: response.message,
      });
    }
  } catch (error) {
    await dispatch({ type: apiType.API_RESPONSE_FAILURE, payload: error });
  }
};
